import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';

class SMGuestList extends SMDashboardBaseView {

  componentDidMount() {
    $('body').addClass('js-split-view');
    $(window).on('resize', this.sizeToFit.bind(this));
    this.addSplitViewModal(this.refs.formContent);
  }

  sizeToFit() {
    if (this.state.display == SMConst.Display.Visible) {
      let $mainTable = $(this.refs.mainTable);
      let $mainTableFooter = $(ReactDOM.findDOMNode(this.refs.mainTableFooter));
      $mainTableFooter.outerWidth($mainTable.outerWidth());
    }
  }

  inviteGuest(e){
    e.preventDefault();
    this.trackPageEvent('od invite reservation');
    if(this.props.delegate && typeof this.props.delegate.inviteActionDidSelect === 'function'){
      this.props.delegate.inviteActionDidSelect(e);
    }
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  render() {
    let reservation = this.props.reservation;

    let user = reservation.user;
    let rows = [];

    // 予約者を出力
    rows.push(
      <div key="guest-1" className="reserve-detail-box">
          <p className="reserve-member__title">宿泊者1</p>
            <img src={user.profile_image} className="reserve-member__img" alt={user.username} />
            <p className="reserve-member__name"><a href={Routes.user_path(user.username)}>{user.name}</a></p>
      </div>
    );

    // 予約者以外の宿泊者出力
    for (let i=0; i < reservation.number_of_guests - 1; i++) {
      let guest = reservation.guest_companions[i];
      let guest_number = i +2;
      let guestKey = 'guest-' + guest_number;
      if (guest) {
        rows.push(
          <div key={"guest-" + guest_number} className="reserve-detail-box">
            <p className="reserve-member__title">宿泊者{guest_number}</p>
            <img src={guest.profile_image} className="reserve-member__img" alt={guest.contact_name} />
            <p className="reserve-member__name"><a href={Routes.user_path(guest.username)}>{guest.name}</a></p>
          </div>
        );
      } else {
        rows.push(
          <div key={"guest-" + guest_number} className="reserve-detail-box">
            <p className="reserve-member__title">宿泊者{guest_number}</p>
            <img src={SMFormatHelper.defaultIcon()} className="reserve-member__img" alt="未登録" />
            <p className="reserve-member__name">未登録</p>
            <p className="reserve-member__link"><a href="#" className="link-hover-border" onClick={this.inviteGuest.bind(this)}><i className="fa fa-envelope mr5">招待URLを送る</i></a></p>
          </div>
        );
      }
    }

    return (
      <div>
        {rows}
      </div>
    );
  }
}

SMGuestList.propTypes = {
  reservation: PropTypes.object.isRequired,
};
export default SMGuestList;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMGuestList.jsx